// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__R2hyE","spin":"loading_spin__nt95l"};